import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'


export default new Vuetify({
  theme: {
    themes: {
      light: {
        //primary: colors.blue.lighten1, // #E53935
        //secondary: colors.red.lighten4, // #FFCDD2
        //memexproject colors
        blue:"#00599e",
        lightblue:"#4f87d0",
        darkblue:"#00316f",
        orange: "#ff7043",
        lightorange:"#ffa270",
        darkorange:"#c63f17",
        darkgreen:"#A9A004",
        primary:"#38737A",
        primaryVariant:"#81B9BF",
        secondary:"#B2EBF2",
        secondaryVariant:"#E5FFFF",
        complementary:"#EAEBEB",
        complementaryVariant:"#F8F9F9",
        white:"#FFFFFF",
        error:"#E70A04",
        onSecondary:"#10191A",
        colorPalettejourney1:"#90C3C9",
        colorPalettejourney2:"#5C6BC0",
        colorPalettejourney3:"#B69BE7",
        colorPalettejourney4:"#9B3D58",
        colorPalettejourney5:"#D9B654",
        colorPalettejourney6:"#E2B080",

        colorPalettejourneylight1:"#E0FBFC",
        colorPalettejourneydark1:"#90C3C9",
        colorPalettejourneylight2:"#F5F8FB",
        colorPalettejourneydark2:"#6A78C5",

        colorPalettejourneylight3:"#FFEAFB",
        colorPalettejourneydark3:"#C1A6EA",
        colorPalettejourneylight4:"#FFECEC",
        colorPalettejourneydark4:"#B66C82",

        colorPalettejourneylight5:"#EFEFFA",
        colorPalettejourneydark5:"#E0C88A",
        colorPalettejourneylight6:"#F5E4C6",
        colorPalettejourneydark6:"#E6958E",

        colorPalettejourneydarker1:"#38737A",
        colorPalettejourneydarker2:"#23338B",
        colorPalettejourneydarker3:"#6E4AB0",
        colorPalettejourneydarker4:"#662238",
        colorPalettejourneydarker5:"#A68730",
        colorPalettejourneydarker6:"#C65454"
      },
      dark: {
        primary: colors.blue.lighten5, // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base, // #3F51B5
        red: colors.red.accent4, // #3F51B5


        colorPalettejourney1:"#90C3C9",
        colorPalettejourney2:"#5C6BC0",
        colorPalettejourney3:"#B69BE7",
        colorPalettejourney4:"#9B3D58",
        colorPalettejourney5:"#D9B654",
        colorPalettejourney6:"#E2B080",

      },
    },
  },
})

Vue.use(Vuetify);